/*@flow*/
import { state } from 'ops';

export default (key: ?string, fallback?: any): any => {
  const base = '$query';
  const keyPath = [base, key].filter(Boolean).join('.');
  return state(keyPath, fallback) || fallback;
};
